import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  constructor(public route: ActivatedRoute) {}

  ngOnInit() {}

  ngOnDestroy() {}

  getRouteTitle() {
    if (this.route.snapshot.firstChild) {
      return this.route.snapshot.firstChild.data.title;
    }
    return '';
  }
}
